module.exports = __webpack_public_path__ + "zillow-src-icon.png?4f605d5ff12d380adce244cad5cb8c04";